var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 4C3.59998 1.79086 5.39084 0 7.59998 0H21.6L32.4 10.8V32C32.4 34.2091 30.6091 36 28.4 36H7.59998C5.39084 36 3.59998 34.2091 3.59998 32V4Z",
    fill: "#079455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.6 0L32.4 10.8H25.6C23.3908 10.8 21.6 9.00914 21.6 6.8V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 27H22.8062C23.3889 27 23.6803 27 23.8409 26.8785C23.9808 26.7727 24.0674 26.6109 24.0778 26.4358C24.0898 26.2347 23.9282 25.9923 23.605 25.5075L21.7988 22.7981C21.5317 22.3975 21.3982 22.1972 21.2299 22.1274C21.0827 22.0664 20.9173 22.0664 20.7702 22.1274C20.6019 22.1972 20.4683 22.3975 20.2012 22.7981L19.7547 23.4679M22.2 27L17.5893 20.3401C17.3241 19.9571 17.1916 19.7656 17.026 19.6983C16.8811 19.6394 16.7189 19.6394 16.5741 19.6983C16.4085 19.7656 16.2759 19.9571 16.0107 20.3401L12.4429 25.4936C12.1051 25.9815 11.9362 26.2255 11.9458 26.4284C11.9542 26.6051 12.0401 26.7691 12.1807 26.8766C12.342 27 12.6388 27 13.2322 27H22.2ZM23.4 18C23.4 18.9941 22.5941 19.8 21.6 19.8C20.6059 19.8 19.8 18.9941 19.8 18C19.8 17.0059 20.6059 16.2 21.6 16.2C22.5941 16.2 23.4 17.0059 23.4 18Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileColor);
export default __webpack_public_path__ + "static/media/file-color.69e1d1d1c14f9bb6f724f61658df520a.svg";
export { ForwardRef as ReactComponent };